
import './LanguageSwitcherSkeleton.scss';

const LanguageSwitcherSkeleton = () => {

  return (
    <div className="language__switcher__skeleton"></div>
  );
};

export default LanguageSwitcherSkeleton;